package com.exura.pages.settings

import com.exura.features.localization.domain.model.BasicLangSet
import com.exura.features.localization.domain.model.Language
import com.exura.features.localization.domain.model.Localization

interface ProfileLang {
    val fields: Fields
    val messages: Messages
    val errors: Errors
    
    val profilePageTitle: String
    val basicInformation: String
    
    interface Fields {
        val fullName: String
        val specialization: String
        val organizationName: String
        val fieldOfActivity: String
        val contactPhoneNumber: String
        val emailAddress: String
        
        val enterFullName: String
        val enterSpecialization: String
        val enterOrganizationName: String
        val enterFieldOfActivity: String
        val enterContactPhoneNumber: String
    }
    
    interface Messages {
        val profileSaved: String
    }
    
    interface Errors {
        val emailCantBeEmpty: String
        val provideCorrectEmail: String
        val fieldCantBeEmpty: String
        val phoneNumberCantBeEmpty: String
        val provideCorrectPhoneNumber: String
    }
}

data object ProfilePolish : ProfileLang {
    override val fields = Fields
    override val messages = Messages
    override val errors = Errors
    
    override val profilePageTitle: String = "Profil"
    override val basicInformation: String = "Podstawowe informacje"
    
    data object Fields : ProfileLang.Fields {
        override val fullName: String = "Imię i nazwisko"
        override val specialization: String = "Specjalizacja"
        override val organizationName: String = "Nazwa organizacji"
        override val fieldOfActivity: String = "Dziedzina działalności"
        override val contactPhoneNumber: String = "Numer telefonu kontaktowego"
        override val emailAddress: String = "Adres e-mail"
        
        override val enterFullName: String = "Wprowadź imię i nazwisko"
        override val enterSpecialization: String = "Wprowadź specjalizację"
        override val enterOrganizationName: String = "Wprowadź nazwę organizacji"
        override val enterFieldOfActivity: String = "Wprowadź dziedzinę działalności"
        override val enterContactPhoneNumber: String = "Wprowadź numer telefonu kontaktowego"
    }
    
    data object Messages : ProfileLang.Messages {
        override val profileSaved: String = "Profil zapisany pomyślnie"
    }
    
    data object Errors : ProfileLang.Errors {
        override val emailCantBeEmpty: String = "E-mail nie może być pusty"
        override val provideCorrectEmail: String = "Podaj prawidłowy adres e-mail"
        override val fieldCantBeEmpty: String = "Pole nie może być puste"
        override val phoneNumberCantBeEmpty: String = "Numer telefonu nie może być pusty"
        override val provideCorrectPhoneNumber: String = "Podaj prawidłowy numer telefonu"
    }
}

data object ProfileEnglish : ProfileLang {
    override val fields = Fields
    override val messages = Messages
    override val errors = Errors
    
    override val profilePageTitle: String = "Profile"
    override val basicInformation: String = "Basic Information"
    
    data object Fields : ProfileLang.Fields {
        override val fullName: String = "Full Name"
        override val specialization: String = "Specialization"
        override val organizationName: String = "Organization Name"
        override val fieldOfActivity: String = "Field of Activity"
        override val contactPhoneNumber: String = "Contact Phone Number"
        override val emailAddress: String = "Email Address"
        
        override val enterFullName: String = "Enter full name"
        override val enterSpecialization: String = "Enter specialization"
        override val enterOrganizationName: String = "Enter organization name"
        override val enterFieldOfActivity: String = "Enter field of activity"
        override val enterContactPhoneNumber: String = "Enter contact phone number"
    }
    
    data object Messages : ProfileLang.Messages {
        override val profileSaved: String = "Profile saved successfully"
    }
    
    data object Errors : ProfileLang.Errors {
        override val emailCantBeEmpty: String = "Email can't be empty"
        override val provideCorrectEmail: String = "Provide a correct email"
        override val fieldCantBeEmpty: String = "Field can't be empty"
        override val phoneNumberCantBeEmpty: String = "Phone number can't be empty"
        override val provideCorrectPhoneNumber: String = "Provide a correct phone number"
    }
}

private val profileLangSet = BasicLangSet<ProfileLang>(
    mapOf(
        Language.POLISH to ProfilePolish,
        Language.ENGLISH to ProfileEnglish,
    )
)

val profileLocalization = Localization<ProfileLang>(profileLangSet)
